module.exports = __webpack_public_path__ + "static/media/YT.8b296b78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/YT.svg
// module id = 2294
// module chunks = 7